// extracted by mini-css-extract-plugin
export default {"gameControls":"Controls_gameControls__eeM59","mineCount":"Controls_mineCount__PXF8X"};